"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.operationRequiresExtractor = exports.isPreSanitizeOperation = exports.isPostSanitizeOperation = exports.getOperationSanitizePhase = exports.TapeBuilderTaskSchema = void 0;
const zod_1 = require("zod");
const OperationNodes = __importStar(require("./operations/index"));
exports.TapeBuilderTaskSchema = zod_1.z.discriminatedUnion('operation', [
    OperationNodes.Asset2Json.TaskSchema,
    OperationNodes.AttachHeader.TaskSchema,
    OperationNodes.Edit.TaskSchema,
    OperationNodes.Filter.TaskSchema,
    OperationNodes.Flatten.TaskSchema,
    OperationNodes.Join.TaskSchema,
    OperationNodes.Pdf2Csv.TaskSchema,
    OperationNodes.PreFilter.TaskSchema,
    OperationNodes.Sanitize.TaskSchema,
    OperationNodes.Stack.TaskSchema,
    OperationNodes.Unzip.TaskSchema,
    // zod4 allows discriminated unions in discriminated unions!!
    OperationNodes.Ai2CsvTransform.TaskSchema,
    OperationNodes.PyXlsx2Csv2.TaskSchema,
    OperationNodes.Xlsx2Csv.TaskSchema,
    OperationNodes.Xlsx2Csv2.TaskSchema,
    OperationNodes.PyXlsxVirtualSheet2Csv.TaskSchema,
    OperationNodes.PyCsvVirtualSheet.TaskSchema,
]);
// Checks exhaustiveness while keeping each operation's literal phase (the
// lint parser does not support `satisfies`).
const classifySanitizePhases = (phases) => phases;
/**
 * Where each operation sits relative to sanitize: `post` operations produce a
 * sanitized tape, `pre` operations feed one. Matches each operation uiNode's
 * `operationType` (a test checks this). Adding a new operation is a compile
 * error until it is classified here.
 */
const OPERATION_SANITIZE_PHASE = classifySanitizePhases({
    attachHeader: 'pre',
    asset2json: 'pre',
    pdf2csv: 'pre',
    preFilter: 'pre',
    pyXlsx2Csv2: 'pre',
    unzip: 'pre',
    xlsx2csv: 'pre',
    ai2Csv: 'post',
    edit: 'post',
    filter: 'post',
    flatten: 'post',
    join: 'post',
    pyCsvVirtualSheet: 'post',
    pyXlsxVirtualSheet2Csv: 'post',
    sanitize: 'post',
    stack: 'post',
    xlsx2csv2: 'post',
});
const getOperationSanitizePhase = (operation) => OPERATION_SANITIZE_PHASE[operation];
exports.getOperationSanitizePhase = getOperationSanitizePhase;
const isPostSanitizeOperation = (operation) => OPERATION_SANITIZE_PHASE[operation] === 'post';
exports.isPostSanitizeOperation = isPostSanitizeOperation;
const isPreSanitizeOperation = (operation) => OPERATION_SANITIZE_PHASE[operation] === 'pre';
exports.isPreSanitizeOperation = isPreSanitizeOperation;
/**
 * Whether each operation needs an extractor callback at execution time
 * (`generateTape`'s `pdfExtractor` / `assetExtractor` / `py*Extractor` /
 * `ai2CsvExtractor` params). Extractor ops turn a binary or AI-backed input
 * into CSV via out-of-process I/O (S3 + a Python worklease / Textract /
 * finleyAi); the pure-CSV ops transform buffers in-process.
 *
 * `operationType` (`tapebuilder_pre/postSanitize`) does NOT distinguish these —
 * both native and extractor ops span both phases — so the classification is an
 * explicit exhaustive map here. A bare (pipeline-less) graph run rejects graphs
 * containing any extractor op, since it wires up none of that infrastructure
 * (see `docs/BBPL_Graph_Primitives_Decouple.md` §6c and `AgentV_Graph_Authoring.md`
 * §7.3). Adding a new operation is a compile error until it is classified here.
 */
const OPERATION_REQUIRES_EXTRACTOR = {
    // Pure-CSV, in-process — no extractor needed.
    sanitize: false,
    filter: false,
    preFilter: false,
    edit: false,
    join: false,
    stack: false,
    flatten: false,
    attachHeader: false,
    // Extractor-backed — need a binary/AI extractor callback.
    asset2json: true,
    pdf2csv: true,
    xlsx2csv: true,
    xlsx2csv2: true,
    pyXlsx2Csv2: true,
    pyXlsxVirtualSheet2Csv: true,
    pyCsvVirtualSheet: true,
    ai2Csv: true,
    unzip: true,
};
/**
 * True if the operation needs an extractor callback (binary/AI → CSV). See
 * {@link OPERATION_REQUIRES_EXTRACTOR}.
 */
const operationRequiresExtractor = (operation) => OPERATION_REQUIRES_EXTRACTOR[operation];
exports.operationRequiresExtractor = operationRequiresExtractor;
//# sourceMappingURL=tasks.js.map